import { IDoka } from './doka';

const Doka:IDoka = window['Doka'];

export const supported = Doka.supported;
export const create = Doka.create;